// Module
var code = `<div class="alert">
  <div>
    <strong>DISCLAIMER:</strong><br><br>
    This form can be used in updating the entire Philippines geographic location dictionary and its PSGC codes.<br>
    This does not include the three main island groups and foreign offices.<br><br>

    <strong>Note that parser follows the updated 10 PSGC code formatting</strong><br>
    <strong>Please download the sample file for the valid excel file format</strong><br><br>
    <strong>Valid geographic level: </strong><br>
    * REGION<br>
    * PROVINCE<br>
    * DISTRICT<br>
    * MUNICIPALITY<br>
    * CITY<br>
    * SUB_MUNICIPALITY<br>
    * SGU<br>
    * BARANGAY<br>
  </div>
</div>
<div class="alert alert--danger">
  Note that the list geographic locations in the file will replace the existing list. <br>
  Please make sure that the list is complete based on the Philippine Standard Geographic Code (PSGC) | Philippine Statistics Authority.
</div>
<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Content:</td>
      <td>
        <file-upload
          ng-model="\$ctrl.contentFile"
          required
          validate-uploaded
          max-files="1"
          show-file-name="true"
          show-remarks="false"
          enable-webcam="false"
          validate="{pattern: '.xls,*.xlsx', size: { max: '3MB'}}">
        </file-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-info"
      ng-click="\$ctrl.downloadXls()">
      Download sample file
    </button>
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-geo-location-dictionary/update-geo-location-dictionary.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;